export default function ({ $axios }) {
  $axios.defaults.timeout = 30000; // 1000 * 30 ms
}
